/** Fucsia Prudence (por defecto en hero y referencia de marca) */
export const PRUDENCE_FUCHSIA = {
  main: '#D81B60',
  light: '#F06292',
  dark: '#AD1457',
};

/**
 * Colores del Hero Prudence.
 * Edita aquí o pasa ?heroBg=#hex y opcional ?heroAccent=#hex en la URL para previsualizar.
 */
export const HERO_THEME = {
  background: PRUDENCE_FUCHSIA.main,
  accent: PRUDENCE_FUCHSIA.light,
  /** 0 = sin velo sobre el video; 0.15–0.35 = leve contraste para el texto del pie */
  videoOverlayOpacity: 0.12,
};

const HEX_COLOR = /^#([0-9A-Fa-f]{3}|[0-9A-Fa-f]{6}|[0-9A-Fa-f]{8})$/;

export function isHexColor(value) {
  return typeof value === 'string' && HEX_COLOR.test(value.trim());
}

function expandHex(hex) {
  const h = hex.replace('#', '');
  if (h.length === 3) {
    return h
      .split('')
      .map((c) => c + c)
      .join('');
  }
  return h.slice(0, 6);
}

function hexToRgb(hex) {
  const h = expandHex(hex);
  return {
    r: parseInt(h.slice(0, 2), 16),
    g: parseInt(h.slice(2, 4), 16),
    b: parseInt(h.slice(4, 6), 16),
  };
}

/** Texto legible sobre fondo sólido */
export function contrastTextOnBackground(hex) {
  const { r, g, b } = hexToRgb(hex);
  const luminance = (0.299 * r + 0.587 * g + 0.114 * b) / 255;
  return luminance > 0.55 ? '#1A1A1A' : '#FFFFFF';
}

function readUrlColor(param) {
  if (typeof window === 'undefined') return null;
  const value = new URLSearchParams(window.location.search).get(param);
  return isHexColor(value) ? value.trim() : null;
}

export function resolveHeroColors(theme) {
  const background =
    readUrlColor('heroBg') ||
    readUrlColor('heroColor') ||
    (isHexColor(HERO_THEME.background) ? HERO_THEME.background : null) ||
    theme.palette.primary.main;

  const accent =
    readUrlColor('heroAccent') ||
    (isHexColor(HERO_THEME.accent) ? HERO_THEME.accent : null) ||
    theme.palette.primary.light;

  const textOnBackground = contrastTextOnBackground(background);
  const logoUrl =
    textOnBackground === '#FFFFFF'
      ? 'url(/images/logos/logo_white.PNG)'
      : 'url(/images/logos/logo_tnonetwork_black.png)';

  const { r, g, b } = hexToRgb(accent);

  return {
    background,
    accent,
    accentRgb: { r, g, b },
    textOnBackground,
    logoUrl,
    videoOverlayOpacity: HERO_THEME.videoOverlayOpacity ?? 0,
  };
}
